import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, KeyRound } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CredentialsCard = ({ token, currentEmail, onEmailChanged }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!newEmail && !newPassword) {
      toast.error('Enter a new email address or a new password');
      return;
    }
    setSaving(true);
    try {
      const res = await axios.put(
        `${API}/profile/credentials`,
        {
          current_password: currentPassword,
          new_email: newEmail || null,
          new_password: newPassword || null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(res.data.message);
      setCurrentPassword('');
      setNewEmail('');
      setNewPassword('');
      if (res.data.token) onEmailChanged?.(res.data.token, res.data.email);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Could not update your sign-in details');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="bg-white" data-testid="credentials-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <KeyRound className="w-5 h-5 text-slate-700" /> Sign-in details
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={submit} className="space-y-3">
          <p className="text-sm text-slate-500">
            You're signed in as <strong>{currentEmail}</strong>. Enter your current password to change either of these.
          </p>
          <Input
            type="password" required placeholder="Current password"
            value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)}
            data-testid="credentials-current-password"
          />
          <Input
            type="email" placeholder="New email address (optional)"
            value={newEmail} onChange={(e) => setNewEmail(e.target.value)}
            data-testid="credentials-new-email"
          />
          <Input
            type="password" placeholder="New password (optional, at least 8 characters)"
            value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
            data-testid="credentials-new-password"
          />
          <Button type="submit" disabled={saving || !currentPassword} className="bg-slate-900 hover:bg-slate-800" data-testid="credentials-save">
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Update sign-in details
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default CredentialsCard;
